var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPush = function SvgPush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.292 10.293a1 1 0 1 0 1.415 1.414l3-3a.997.997 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.415 1.414L6.585 7H1a1 1 0 1 0 0 2h5.584zM14 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
    clipRule: "evenodd"
  })));
};
export default SvgPush;